<div class="panel p-4 h-full rounded-3xl bg-white/60 dark:bg-white/10 duration-200">
    <ng-content></ng-content>
</div>